'use client'
import React from 'react';


interface CardProps {
  requirements: string[];
  title: string;
  goodToHave: string[];
  isActive: boolean;
  onClick: () => void;
}

const CareerCard: React.FC<CardProps> = ({ requirements, title, goodToHave, isActive, onClick }) => {
  return (
    <div>
      <button
        onClick={onClick}
        className="w-full flex justify-between items-center px-6 rounded-2xl py-4 border-[1px] border-gray-500 cursor-pointer"
        aria-label="Click to reveal job details"
      >
        <div>
          <p className="text-base sm:text-2xl font-normal text-white text-left mb-4">
            {title}
          </p>
          <div className='flex text-xs sm:text-sm font-semibold text-black gap-2'>
            <div className='bg-gray-300 rounded-2xl px-4 py-1'>Full time</div>
            <div className='bg-gray-300 rounded-2xl px-4 py-1'>Location: Remote</div>
          </div>
        </div>

        <div
          className={`size-[22px] rounded-full border-2 flex items-center justify-center text-xl transition-all duration-500
            ${isActive ? "border-red-500 text-red-500 rotate-45" : "border-yellow-400 text-yellow-400"}`}
        >
          +
        </div>
      </button>

      <div
        className={`transition-all duration-1000 overflow-hidden origin-bottom px-4
        ${isActive ? "max-h-[1000px] opacity-100" : "max-h-0 opacity-0"}`}
      >
        <div className="py-6 grid lg:grid-cols-2 gap-6">
          <div>
            <p className="text-2xl font-semibold text-yellow-400">Requirements</p>
            <ul className="mt-4 space-y-2">
              {requirements.map((e, id) => (
                <li key={id}>- {e}</li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-2xl font-semibold text-yellow-400">Good To Haves</p>
            <ul className="mt-4 space-y-2">
              {goodToHave.map((e, id) => (
                <li key={id}>- {e}</li>
              ))}
            </ul>
          </div>
        </div>

        <button
          aria-label="Apply for this job position"
          onClick={() => {
            const applySection = document.getElementById('apply');
            if (applySection) {
              const yOffset = -80;
              const y =
                applySection.getBoundingClientRect().top + window.pageYOffset + yOffset;
              window.scrollTo({ top: y, behavior: 'smooth' });
            }
          }}
          className="inline-flex items-center justify-center
          rounded-md font-semibold px-6 py-3 transition duration-200
          disabled:opacity-50 disabled:cursor-not-allowed bg-[#F0C869] 
          text-black hover:bg-yellow-400 active:bg-yellow-600 mb-4 
          shadow-[0_4px_10px_0_rgba(240,200,105,0.5)] 
          hover:shadow-[0_6px_15px_0_rgba(240,200,105,0.7)]"
        >
          Apply Now
        </button>

      </div>
    </div>
  );
};


export default CareerCard;
